import { OnDestroy } from '@angular/core';
import {
  FormViewAdapter,
  FormControlState
} from 'ngrx-forms';
import { Subscription } from 'rxjs';
import {
  filter,
  debounceTime,
  distinctUntilChanged,
  skipWhile
} from 'rxjs/operators';
import { AbstractInputComponent } from './abstract-input.component';

export abstract class AbstractNgrxInputAdapterDirective<
  V,
  F extends FormControlState<any> = FormControlState<any>
> implements FormViewAdapter, OnDestroy {
  protected _subscriptions = new Subscription();

  protected constructor(
    protected readonly component: AbstractInputComponent<V, F>,
  ) {}

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public setIsDisabled(isDisabled: boolean): void {
    this.component.disabled = isDisabled;
  }

  public setOnChangeCallback(fn: (value: V) => void): void {
    this._subscriptions.add(
      this.component.formControl.ngrxValueChanges$
        .pipe(
          skipWhile(() => !this.component.initialized),
          debounceTime(100),
          distinctUntilChanged((a, b) => !this.component.hasChanged(a, b)),
        )
        .subscribe(fn),
    );
  }

  public setOnTouchedCallback(fn: () => void): void {
    this._subscriptions.add(
      this.component.formControl.ngrxTouchedChanges$
        .pipe(filter((t) => !!t))
        .subscribe(fn),
    );
  }

  public setViewValue(value: V): void {
    this.component.setValue(value);
  }
}
